<template>
    <div class="teaser full-screen d-flex flex-column align-items-top justify-content-start">
        <div class="d-flex justify-content-end align-items-center mt-5 mr-4">
            <router-link :to="{ name: 'auth.login' }" tag="div" class="btn outlined action wide mr-5">
                Log in
            </router-link>

            <router-link :to="{ name: 'auth.signup' }" tag="div" class="btn outlined action wide">
                Sign in
            </router-link>
        </div>

        <router-view></router-view>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
    .teaser {
        background: #d3324d;
    }
</style>



// WEBPACK FOOTER //
// Teaser.vue?841592da